import { render, staticRenderFns } from "./wind.vue?vue&type=template&id=2e20269c&scoped=true&"
import script from "./wind.vue?vue&type=script&lang=js&"
export * from "./wind.vue?vue&type=script&lang=js&"
import style0 from "./wind.vue?vue&type=style&index=0&id=2e20269c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e20269c",
  null
  
)

export default component.exports